import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CheckoutService } from './checkout-config.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-checkout-config',
  templateUrl: './checkout-config.component.html',
  styleUrls: ['./checkout-config.component.scss']
})
export class CheckoutConfig {
  public isLoaded: boolean = true;

  public checkout = new FormGroup({
    urlImagemLogo: new FormControl<string | null>(''),
    colorButton: new FormControl<string | null>('#000000'),
    colorWindow: new FormControl<string | null>('#FFFFFF'),
    colorBotton: new FormControl<string | null>('#F5F5F5')
  });

  constructor(
    private checkoutService: CheckoutService,
    private toastr: ToastrService
  ) {
    this.loadScreen();
  }

  private loadScreen(): void {
    this.isLoaded = false;

    this.checkoutService
      .getCustomizationColorUser()
      .then((res) => {
        const cfg = (res && (res.customizationColor || res)) || {};

        this.checkout.patchValue(
          {
            urlImagemLogo: cfg.urlImagemLogo ?? '',
            colorButton: cfg.colorButton ?? '#000000',
            colorWindow: cfg.colorWindow ?? '#FFFFFF',
            colorBotton: cfg.colorBotton ?? '#F5F5F5'
          },
          { emitEvent: false }
        );

        this.isLoaded = true;
      })
      .catch(() => {
        this.isLoaded = true;
      });
  }

  saveConfig(): void {
    if (this.checkout.invalid) {
      return;
    }

    const payload = this.checkout.value as {
      urlImagemLogo: string | null;
      colorButton: string | null;
      colorWindow: string | null;
      colorBotton: string | null;
    };

    this.isLoaded = false;

    this.checkoutService
      .saveCustomizationColorUser(payload)
      .then(() => {
        this.toastr.success('Configurações salvas com sucesso!');
        this.isLoaded = true;
      })
      .catch(() => {
        this.toastr.error('Erro ao salvar configurações.');
        this.isLoaded = true;
      });
  }
}
